var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isGBWill)?_c('h2',[_vm._v("What is your marital status?")]):_c('h2',[_vm._v("Are you married or do you have a life partner?")]),_vm._v(" "),_c('ValidationObserver',{ref:"observer"},[_c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('ValidationProvider',{attrs:{"id":"marital_status","name":"marital_status","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [(_vm.isGBWill)?_c('RadioSelect',{attrs:{"items":[
            { value: 'MARRIED', text: 'Married' },
            { value: 'SINGLE', text: 'Single' },
            {
              value: 'LIVING_BUT_NOT_MARRIED',
              text: 'Living with a partner but not married',
            },
            { value: 'CIVIL_PARTNERSHIP', text: 'Civil Partnership' },
            { value: 'ENGAGED', text: 'Engaged' },
            { value: 'WIDOWED', text: 'Widowed' },
            {
              value: 'WIDOWED_AND_REMARRIED',
              text: 'Widowed and remarried',
            },
            {
              value: 'MARRIED_BUT_SEPARATED',
              text: 'Married but separated',
            },
            {
              value: 'CIVIL_PARTNERSHIP_BUT_SEPARATED',
              text: 'Civil partnership but separated',
            },
            { value: 'DIVORCED', text: 'Divorced' },
          ],"color":'white',"errors":errors,"group":'marital_status'},model:{value:(_vm.maritalStatus),callback:function ($$v) {_vm.maritalStatus=$$v},expression:"maritalStatus"}}):_c('RadioSelect',{attrs:{"items":[
            { value: 'MARRIED', text: 'Yes' },
            { value: 'NOT_MARRIED', text: 'No' },
          ],"color":'white',"errors":errors,"group":'marital_status'},model:{value:(_vm.maritalStatus),callback:function ($$v) {_vm.maritalStatus=$$v},expression:"maritalStatus"}})]}}])}),_vm._v(" "),_c('div',{staticClass:"button-container"},[_c('DefaultButton',{attrs:{"callout":'left',"small":true},on:{"defaultButtonClicked":_vm.redirectBack}}),_vm._v(" "),_c('GradientButton',{attrs:{"title":'Next',"small":true,"type":'submit',"callout":'right',"loading":_vm.buttonLoading}})],1)],1)],1),_vm._v(" "),_c('ErrorSnackbar',{model:{value:(_vm.showError),callback:function ($$v) {_vm.showError=$$v},expression:"showError"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }